import { PinwheelEvents } from './PinwheelEvents';

export const pinwheelEventNames: Partial<Record<PinwheelEvents, string>> = {
  [PinwheelEvents.PinWheelError]: 'Pinwheel Error Occurred',

  [PinwheelEvents.BillSwitchSuccess]: 'Pinwheel Bill Switch Successful',
  [PinwheelEvents.BillCancelSuccess]: 'Pinwheel Bill Cancel Successful',
  [PinwheelEvents.ExternalAccountConnected]:
    'Pinwheel External Account Connected',
  [PinwheelEvents.MerchantLoginSuccess]: 'Pinwheel Merchant Login Successful',
};
